import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=31c6ac88&"
import script from "./Legend.vue?vue&type=script&lang=js&"
export * from "./Legend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports